// extracted by mini-css-extract-plugin
export var backupIcon = "_p0-1";
export var image = "_p0-0";